import { onError } from '@apollo/client/link/error';

import { ApolloClient, ApolloProvider } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
import { createUploadLink } from 'apollo-upload-client';
import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { cache } from './cache';
import * as serviceWorker from './serviceWorker';
import { Logger } from './Logger';

// @ts-ignore
const ROARR = (globalThis.ROARR = globalThis.ROARR || {});
// @ts-ignore
ROARR.write = message => {
  console.log(JSON.parse(message));
};

const getToken = (): string | null => {
  const authorization = sessionStorage.getItem('authorization');
  if (authorization) {
    const auth = JSON.parse(authorization);
    return auth.token || null;
  }
  return null;
};

const link = createUploadLink({
  uri: process.env.REACT_APP_SERVER_URL,
  credentials: 'include'
});

const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: getToken()
    }
  };
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(error => {
      if (error.originalError?.name === 'SecurityException') {
        sessionStorage.removeItem('authorization');
        window.location.reload();
      }
    });
});

export const client = new ApolloClient({
  cache,
  link: authLink.concat(errorLink).concat(link),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    }
  }
});

const theme = createMuiTheme({
  spacing: 4,
  palette: {
    background: {
      paper: '#fff',
      default: '#fafafa'
    },
    primary: {
      main: '#000'
    },
    secondary: grey
  },
  overrides: {
    MuiTypography: {
      gutterBottom: {
        marginBottom: 16
      }
    }
  }
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MuiThemeProvider>
  </ApolloProvider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
Logger.info('Backoffice app started');
